import { object, string, number, boolean, array } from "yup";
import { contactValidationSchema } from "../contact-form";
import { TIMEZONES } from "components/select";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notANumber = intl.formatMessage({ id: "app.form.notanumber" });
  const invalidIpAddress = intl.formatMessage({ id: "app.form.invalidIpAddress" });
  const invalidTimeZone = intl.formatMessage({ id: "app.form.invalidTimeZone" });

  return object().shape({
    codename: string().required(requiredText),
    description: string().required(requiredText),
    mobileBox: boolean().nullable(),
    usuallyDisconnected: boolean().nullable(),
    allowsConcurrentEvents: boolean().nullable(),
    connectivityFixedIp: boolean().nullable(),
    allowQod: boolean().nullable(),
    msisdnQod: string().when("allowQod", {
      is: true,
      then: schema => schema.required(requiredText),
      otherwise: schema => schema.nullable(),
    }),
    contacts: array().of(contactValidationSchema(requiredText, intl)),
    proxyPtz: object()
      .shape({
        protocol: string().nullable(),
        hostname: string().nullable(),
        port: number(notANumber)
          .typeError(notANumber)
          .nullable(),
      })
      .nullable(),
    awsElasticIps: array()
      .of(
        string()
          .trim()
          .required(requiredText)
          .matches(
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            invalidIpAddress
          )
      )
      .nullable(),
    place: object().shape({
      address: string().required(requiredText),
      serverNtp: string()
        .nullable()
        .required(requiredText),
      timeZone: string()
        .nullable()
        .required(requiredText)
        .oneOf(TIMEZONES, invalidTimeZone),
      daylightSaving: boolean().nullable(),
      name: string().required(requiredText),
      telephone: string().required(requiredText),
      geo: object().shape({
        latitude: number(notANumber)
          .required(requiredText)
          .typeError(notANumber),
        longitude: number(notANumber)
          .required(requiredText)
          .typeError(notANumber),
      }),
    }),
  });
};
